import React from "react";
import {
  PageBackward,
  PageBackwardFast,
  PageForward,
  PageForwardFast,
  PageZoomPlus,
  PageZoomMinus,
  ControlPanelContainer,
  ControlPanelLeft,
  ControlPanelRight,
} from "./ControlPanelElements";

const ControlPanel = ({
  numPages,
  pageNumber,
  setPageNumber,
  setScale,
  scale,
}) => {
  const isFirstPage = pageNumber === 1;
  const isLastPage = pageNumber === numPages;

  const goToFirstPage = () => {
    if (!isFirstPage) setPageNumber(1);
  };

  const goToPreviousPage = () => {
    if (!isFirstPage) setPageNumber(pageNumber - 1);
  };

  const goToNextPage = () => {
    if (!isLastPage) setPageNumber(pageNumber + 1);
  };

  const goToLastPage = () => {
    if (!isLastPage) setPageNumber(numPages);
  };

  const isMinZoom = scale <= 0.8;
  const isMaxZoom = scale >= 2.0;

  const zoomOut = () => {
    if (!isMinZoom) setScale(scale - 0.1);
  };

  const zoomIn = () => {
    if (!isMaxZoom) setScale(scale + 0.1);
  };

  return (
    <ControlPanelContainer>
      <ControlPanelLeft>
        <PageBackwardFast isFirstPage={isFirstPage} onClick={goToFirstPage} />
        <PageBackward isFirstPage={isFirstPage} onClick={goToPreviousPage} />
        Pagina {pageNumber} din {numPages}
        <PageForward isLastPage={isLastPage} onClick={goToNextPage} />
        <PageForwardFast isLastPage={isLastPage} onClick={goToLastPage} />
      </ControlPanelLeft>
      <ControlPanelRight>
        <PageZoomPlus isMaxZoom={isMaxZoom} onClick={zoomIn} />
        {(scale * 100).toFixed()} %
        <PageZoomMinus isMinZoom={isMinZoom} onClick={zoomOut} />
      </ControlPanelRight>
    </ControlPanelContainer>
  );
};

export default ControlPanel;
